import {useSelector} from 'react-redux'
import {useRoleUser} from './useRoleUser'
import styled from 'styled-components'
import {FC} from 'react'

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 4px;
`

interface BadgeProps {
  value: number
  colorClass?:
    | 'badge-primary'
    | 'badge-secondary'
    | 'badge-success'
    | 'badge-danger'
    | 'badge-warning'
    | 'badge-info'
    | 'badge-light'
    | 'badge-dark'
}

export const Badge: FC<BadgeProps> = ({value, colorClass}) => {
  const visibilityClass = value >= 1 ? 'visible' : 'invisible'
  if (value === 0) return null
  return <div className={`badge badge-pill ${colorClass} ${visibilityClass}`}>{value}</div>
}

Badge.defaultProps = {
  colorClass: 'badge-success',
}

export const useNotificationBadge = (menuId: string) => {
  const role = useRoleUser()

  /** @note dashboard */
  const isDashboardMenu = menuId === 'Dashboard'
  /** @note management/order */
  const isManagementOrderMenu = menuId === 'management/order'
  const isManagementSIMenu = menuId === 'management/sip'
  /** @note management/order */
  const isManagementOrderItem = menuId === 'management/order/all'
  /** @note negotiate */
  const isNegotiateMenu = menuId === 'negotiate'
  /** @note management/so */
  const isManagementSoMenu = menuId === 'management/so'
  /** @note management/kontrak */
  const isManagementKontrakMenu = menuId === 'management/kontrak"'
  /** @note management/si/all */
  const isManagementSiAllMenu = menuId === 'management/si/all'
  /** @note management/sip */
  const isManagementSipMenu = menuId === 'management/sip'
  /** @note financial */
  const isFinancialMenu = menuId === 'financial'
  /** @note approval/contract */
  const isApprovalContractMenu = menuId === 'approval/contract'
  /** @note approval/sip */
  const isApprovalSipMenu = menuId === 'approval/sip'
  /** @note approval/sales-order */
  const isApprovalSalesOrderMenu = menuId === 'approval/sales-order'
  /** @note management/order/reject */
  const isManangementOrderRejectMenu = menuId === 'management/order/reject'
  /** @note management/order/finish */
  const isManagementOrderFinish = menuId === 'management/order/finish'
  /** @note management/order/amandement */
  const isManagementOrderAmandementMenu = menuId === 'management/order/amandement'
  /** @note management/approval */
  const isApprovalMenu = menuId === 'approval'

  const isSIProcess = menuId === 'management/si/process'
  const isSIAmend = menuId === 'management/si/amandemen'

  const notifOrder = useSelector((state: any) => state.notif.notifOrder)
  const notifOrderSalesAdmin = useSelector((state: any) => state.notif.notifOrderSalesAdmin)
  const notifContract = useSelector((state: any) => state.notif.notifContract)
  const notifSalesOrder = useSelector((state: any) => state.notif.notifSalesOrder)
  const notifSIP = useSelector((state: any) => state.notif.notifSIP)
  const notifContractOto = useSelector((state: any) => state.notif.notifContractOto)
  const notifSIPOto = useSelector((state: any) => state.notif.notifSIPOto)
  const notifSOOto = useSelector((state: any) => state.notif.notifSalesOrderOto)
  const notifSIPSA = useSelector((state: any) => state.notif.notifSIPSA)
  const notifApprovalSA = useSelector((state: any) => state.notif.notifApprovalSA)
  const notifContractSA = useSelector((state: any) => state.notif.notifContractSA)
  const notifSalesOrderSA = useSelector((state: any) => state.notif.notifSalesOrderSA)
  const notifOrderCus = useSelector((state: any) => state.notif.notifOrderCus)
  const notifOrderSalesPI = useSelector((state: any) => state.notif.notifOrderSalesPI)
  const notifOrderRevisi = useSelector((state: any) => state.notif.notifOrderRevisi)
  const notifOrderReject = useSelector((state: any) => state.notif.notifOrderReject)
  const notifOrderSelesai = useSelector((state: any) => state.notif.notifOrderSelesai)
  const notifNego = useSelector((state: any) => state.notif.notifNego.total)
  const notifFindocApp = useSelector((state: any) => state.notif.notifFindocApp)
  const notifFindocRej = useSelector((state: any) => state.notif.notifFindocRej)
  const notifFindocRev = useSelector((state: any) => state.notif.notifFindocRev)
  const notifFindocSent = useSelector((state: any) => state.notif.notifFindocSent)
  const notifFindocFinance = useSelector((state: any) => state.notif.notifFindocFinance)
  const notifNonSales = useSelector((state: any) => state.notif.notifNonSales)
  const notifAmandemenContract = useSelector((state: any) => state.notif.notifAmandemenContract)
  const notifAmandemenOrder = useSelector((state: any) => state.notif.notifAmandemenOrder)

  const notifSIProcess = useSelector((state: any) => state.notif.notifSIProcess)
  const notifSIAmend = useSelector((state: any) => state.notif.notifSIAmend)
  const notifSITotal = useSelector((state: any) => state.notif.notifSITotal)

  const NotifOrder = () => <Badge value={notifOrder} colorClass='badge-success' />
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const NotifOrderSalesAdmin = () => (
    <Badge value={notifOrderSalesAdmin} colorClass='badge-success' />
  )
  const NotifContract = () => <Badge value={notifContract} colorClass='badge-success' />
  const NotifSalesOrder = () => <Badge value={notifSalesOrder} colorClass='badge-success' />
  const NotifSIP = () => <Badge value={notifSIP} colorClass='badge-success' />
  const NotifContractOto = () => <Badge value={notifContractOto} colorClass='badge-success' />
  const NotifSIPOto = () => <Badge value={notifSIPOto} colorClass='badge-success' />
  const NotifSOOto = () => <Badge value={notifSOOto} colorClass='badge-success' />
  const NotifSIPSA = () => <Badge value={notifSIPSA} colorClass='badge-success' />
  const NotifApprovalSA = () => <Badge value={notifApprovalSA} colorClass='badge-success' />
  const NotifContractSA = () => <Badge value={notifContractSA} colorClass='badge-warning' />
  const NotifSalesOrderSA = () => <Badge value={notifSalesOrderSA} colorClass='badge-success' />
  const NotifOrderCus = () => <Badge value={notifOrderCus} colorClass='badge-secondary' />
  const NotifOrderSalesPI = () => <Badge value={notifOrderSalesPI} colorClass='badge-secondary' />
  const NotifOrderRevisi = () => <Badge value={notifOrderRevisi} colorClass='badge-warning' />
  const NotifOrderReject = () => <Badge value={notifOrderReject} colorClass='badge-danger' />
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const NotifOrderSelesai = () => <Badge value={notifOrderSelesai} colorClass='badge-success' />
  const NotifNego = () => <Badge value={notifNego} colorClass='badge-success' />
  const NotifFindocApp = () => <Badge value={notifFindocApp} colorClass='badge-success' />
  const NotifFindocRej = () => <Badge value={notifFindocRej} colorClass='badge-danger' />
  const NotifFindocRev = () => <Badge value={notifFindocRev} colorClass='badge-warning' />
  const NotifFindocSent = () => <Badge value={notifFindocSent} colorClass='badge-secondary' />
  const NotifFindocFinance = () => <Badge value={notifFindocFinance} colorClass='badge-success' />
  const NotifNonSales = () => <Badge value={notifNonSales} colorClass='badge-success' />
  const NotifAmandemenContract = () => (
    <Badge value={notifAmandemenContract} colorClass='badge-info' />
  )
  const NotifAmandemenOrder = () => <Badge value={notifAmandemenOrder} colorClass='badge-info' />
  const NotifSIProcess = () => <Badge value={notifSIProcess} colorClass='badge-warning' />
  const NotifSIAmend = () => <Badge value={notifSIAmend} colorClass='badge-info' />

  const NotificationBadge = () => {
    if (isDashboardMenu) return <></>

    if (role.isCustomer) {
      if (isManagementSoMenu) return <NotifSalesOrder />
      if (isManagementKontrakMenu) return <NotifContract />
      if (isManagementSiAllMenu) return <NotifSIP />
      if (isNegotiateMenu) return <NotifNego />
      if (isManangementOrderRejectMenu) return <NotifOrderReject />
      if (isManagementOrderAmandementMenu) return <NotifAmandemenOrder />
      if (isManagementOrderFinish) return <NotifNonSales />
      if (isManagementOrderItem) {
        return (
          <Wrapper>
            <NotifOrderCus />
            <NotifOrderRevisi />
            <NotifOrderReject />
            <NotifNonSales />
          </Wrapper>
        )
      }
      if (isFinancialMenu) {
        return (
          <Wrapper>
            {/* <NotifFindocApp /> */}
            <NotifFindocRej />
            <NotifFindocRev />
          </Wrapper>
        )
      }
    }

    if (role.isAdmin) {
      if (isManagementOrderItem) return <NotifOrder />
    }

    if (role.isFinance) {
      if (isFinancialMenu) {
        return (
          <Wrapper>
            <NotifFindocSent />
            <NotifFindocRev />
            <NotifFindocRej />
          </Wrapper>
        )
      }
    }

    if (role.isOtorisator) {
      if (isApprovalContractMenu) return <NotifContractOto />
      // if (isApprovalSipMenu) return <NotifSIPOto />
      if (isApprovalSalesOrderMenu) return <NotifSOOto />
    }

    if (role.isSalesAdmin) {
      if (isNegotiateMenu) return <NotifNego />
      if (isManagementOrderAmandementMenu)
        return (
          <Wrapper>
            <NotifOrderSalesPI />
            <NotifAmandemenOrder />
          </Wrapper>
        )
      if (isManangementOrderRejectMenu) return <NotifOrderReject />
      if (isManagementOrderFinish) return <NotifNonSales />
      if (isManagementOrderItem)
        return (
          <Wrapper>
            <NotifOrderSalesPI />
            <NotifOrderRevisi />
            <NotifOrderReject />
            <NotifNonSales />
            <NotifAmandemenOrder />
          </Wrapper>
        )
    }

    if (role.isSalesAnper) {
      // if (isManagementSoMenu) return <NotifApprovalSA />
      if (isManagementSoMenu) return <NotifSalesOrderSA />
      if (isFinancialMenu) {
        return (
          <Wrapper>
            <NotifFindocSent />
            <NotifFindocRej />
          </Wrapper>
        )
      }

      if(isSIProcess) return <NotifSIProcess/>
      if(isSIAmend) return <NotifSIAmend/>

      if (isManagementSipMenu) return <NotifSIPSA />
      if (isManagementKontrakMenu) {
        return (
          <Wrapper>
            <NotifContractSA />
            <NotifAmandemenContract />
          </Wrapper>
        )
      }
    }

    return <></>
  }

  const NotificationBadgeTotal = () => {
    // NotifOrderCus + NotifOrderRevisi + NotifOrderReject + NotifNonSales
    if (role.isCustomer && isManagementOrderMenu) {
      const value: number =
        (notifOrderCus ?? 0) +
        (notifOrderRevisi ?? 0) +
        (notifOrderReject ?? 0) +
        (notifNonSales ?? 0)
      return <Badge value={value} colorClass='badge-light' />
    }

    if ((role.isCustomer || role.isSalesAnper) && isManagementSIMenu) {
      return <Badge value={notifSITotal} colorClass='badge-light' />
    }

    // NotifOrderSalesPI + NotifOrderRevisi + NotifOrderReject + NotifNonSales + NotifAmandemenOrder
    if (role.isSalesAdmin && isManagementOrderMenu) {
      const value: number =
        (notifOrderSalesPI ?? 0) +
        (notifOrderRevisi ?? 0) +
        (notifOrderReject ?? 0) +
        (notifNonSales ?? 0) +
        notifAmandemenOrder
      return <Badge value={value} colorClass='badge-light' />
    }

    // NotifContractSA + NotifAmandemenContract
    if (role.isSalesAnper && isManagementKontrakMenu) {
      const value: number = (notifContractSA ?? 0) + (notifAmandemenContract ?? 0)
      return <Badge value={value} colorClass='badge-light' />
    }

    // NotifContractOto + NotifSIPOto + NotifSOOto
    if (role.isOtorisator && isApprovalMenu) {
      const value: number = (notifContractOto ?? 0) + (notifSIPOto ?? 0) + (notifSOOto ?? 0)
      return <Badge value={value} colorClass='badge-light' />
    }

    return <></>
  }

  return {
    NotificationBadge,
    NotificationBadgeTotal,
  }
}
